import * as React from "react";
import Stack from "@mui/material/Stack";
import TrapFocus from "@mui/material/Unstable_TrapFocus";
import Paper from "@mui/material/Paper";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export default function CookiesBanner() {
  // Read cookie value to determine if banner should be shown
  const [bannerOpen, setBannerOpen] = React.useState(() => {
    return cookies.get("acceptCookie")==undefined; // Show banner if cookie is not set
  });

  const handleAcceptCookies = () => {
    cookies.set("acceptCookie", "true", { path: "/", maxAge: 60 * 60 * 24 * 365 }); // Expires in 1 year
    setBannerOpen(false);
  };

  const handleRejectCookies = () => {
    cookies.set("acceptCookie", "false", { path: "/", maxAge: 60 * 60 * 24 * 365 });
    setBannerOpen(false);
  };

  if (!bannerOpen) return null; // Hide banner if cookies are already accepted/rejected

  return (
    <TrapFocus open disableAutoFocus disableEnforceFocus>
      <Fade appear={false} in={bannerOpen}>
        <Paper
          role="dialog"
          aria-modal="false"
          aria-label="Cookie banner"
          square
          variant="outlined"
          tabIndex={-1}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            m: 0,
            p: 2,
            borderWidth: 0,
            borderTopWidth: 1,
            zIndex: 1000,
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            sx={{ justifyContent: "space-between", gap: 2 }}
          >
            <Box sx={{ flexShrink: 1, alignSelf: { xs: "flex-start", sm: "center" } }}>
              <Typography sx={{ fontWeight: "bold" }}>
                This website uses cookies
              </Typography>
              <Typography variant="body2">
                By clicking 'Accept', you agree to the storage of cookies on your device
                to improve user experience and personalize content in accordance with our
                Cookie Policy.
              </Typography>
            </Box>
            <Stack
              direction={{ xs: "row-reverse", sm: "row" }}
              sx={{
                gap: 2,
                flexShrink: 0,
                alignSelf: { xs: "flex-end", sm: "center" },
              }}
            >
              <Button size="small" onClick={handleAcceptCookies} variant="contained">
                Allow all
              </Button>
              <Button size="small" onClick={handleRejectCookies}>
                Reject all
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Fade>
    </TrapFocus>
  );
}
